var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"disclaimer-popup__wrapper",style:(_vm.popupStyles)},[_c('i',{staticClass:"disclaimer-popup__icon",on:{"click":_vm.onClose}}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }